import { fetchScrubStats } from "../api/ScrubStatsAPI";




export const initialState = {
    stats: {
        "MISSING_COUNT": 0,
        "LOST_COUNT": 0
    },
    loading: false
}

export const ScrubStatsReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_DATA":
            const {dispatcher} = action.data;
            fetchScrubStats({}, dispatcher)
            return {...initialState, loading: true}
        case "SET_DATA":
            return { ...state, stats: action.data, loading: false }  
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/ScrubStatsReducer.js